import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusBannerComponent } from '@mode/shared/ui';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import { Observable } from 'rxjs';

@Component({
  selector: 'mode-publish-dataset-banner',
  standalone: true,
  imports: [CommonModule, StatusBannerComponent],
  templateUrl: './publish-dataset-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublishDatasetBannerComponent {
  @Input() fromReport = false;
  datasetRepublishing$: Observable<boolean>;

  constructor(private featureFlagsFacade: FeatureFlagsFacade) {
    this.datasetRepublishing$ = this.featureFlagsFacade.asObservable(FeatureFlag.DatasetRepublishing);
  }
}
